import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { CURRENCY_SIGN } from 'constants/currencies'
import { prettify } from 'utils/standard/numbers'

import Text from '../../component'

const CurrencyComponent = ({ currency, value, ...props }) => (
  <Text {...props}>
    {prettify(value, { floatPartSize: 2 })}
    {CURRENCY_SIGN[currency]}
  </Text>
)

CurrencyComponent.propTypes = {
  currency: PropTypes.string,
  value: PropTypes.number,
}

export default observer(CurrencyComponent)
